import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/color-metal-nobackground.png'


const _withScopeId = n => (_pushScopeId("data-v-5416d82b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title__current__page" }
const _hoisted_2 = {
  key: 1,
  class: "q-px-sm"
}
const _hoisted_3 = { style: {"display":"flex","align-items":"center","min-width":"15rem"} }
const _hoisted_4 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_5 = { class: "app__label--medium" }
const _hoisted_6 = { class: "app__color--golden" }
const _hoisted_7 = {
  key: 2,
  style: {"display":"flex","align-items":"center"},
  class: "q-px-sm"
}
const _hoisted_8 = {
  key: 0,
  class: "app__color--label"
}
const _hoisted_9 = {
  key: 3,
  style: {"display":"flex","align-items":"center","max-height":"36px","min-height":"36px"},
  class: "q-px-sm"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "row no-wrap q-pa-md" }
const _hoisted_12 = { class: "column" }
const _hoisted_13 = { class: "text-h6 q-mb-md app__color--label" }
const _hoisted_14 = { class: "column items-center" }
const _hoisted_15 = { class: "text-h6 q-mb-md" }
const _hoisted_16 = { class: "app__color--label" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "row items-center no-wrap" }
const _hoisted_19 = {
  class: "text-center",
  style: {"padding":"10px"}
}
const _hoisted_20 = { class: "text-h6" }
const _hoisted_21 = { class: "q-mt-md q-mb-xs" }
const _hoisted_22 = { class: "text-subtitle2" }
const _hoisted_23 = {
  key: 0,
  style: {"width":"100%","display":"flex","justify-content":"center","align-items":"center","position":"relative"}
}
const _hoisted_24 = {
  key: 1,
  class: "app__back__bar--title"
}
const _hoisted_25 = {
  key: 4,
  style: {"margin-left":"auto","display":"flex"}
}
const _hoisted_26 = {
  key: 1,
  style: {"width":"100%","display":"flex"}
}
const _hoisted_27 = {
  key: 0,
  style: {"width":"100%","display":"flex","align-items":"center"}
}
const _hoisted_28 = {
  key: 0,
  style: {"display":"flex","align-items":"center","width":"100%"},
  class: "q-px-sm"
}
const _hoisted_29 = {
  key: 0,
  class: "app__color--label"
}
const _hoisted_30 = { style: {"min-width":"fit-content","text-align":"right","align-items":"center"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","text-align":"center","padding-top":"7px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"15rem"}
  })
], -1))
const _hoisted_32 = {
  key: 1,
  class: "q-pa-lg ecran-container"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { style: {"display":"flex","flex-direction":"column","justify-content":"flex-start"} }
const _hoisted_35 = { class: "app__property--small" }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { style: {"display":"flex","flex-direction":"column","justify-content":"flex-start"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "app__property--medium",
  style: {}
}, null, -1))
const _hoisted_39 = { key: 3 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_MenuApp = _resolveComponent("MenuApp")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_ContacteleMeleColorMetal = _resolveComponent("ContacteleMeleColorMetal")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpR fFf" }, {
    default: _withCtx(() => [
      (_ctx.sessionIsValid)
        ? (_openBlock(), _createBlock(_component_q_header, {
            key: 0,
            bordered: "",
            style: {"background-color":"#FFFFFF","color":"black"}
          }, {
            default: _withCtx(() => [
              (_ctx.$q.platform.is.desktop)
                ? (_openBlock(), _createBlock(_component_q_toolbar, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        flat: "",
                        round: "",
                        icon: "menu",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leftDrawerOpen = !_ctx.leftDrawerOpen))
                      }),
                      _createElementVNode("img", {
                        src: _imports_0,
                        style: {"width":"15rem","cursor":"pointer"},
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)))
                      }),
                      (_ctx.$q.screen.width > 1900)
                        ? (_openBlock(), _createBlock(_component_q_toolbar_title, {
                            key: 0,
                            class: "app__color--gray"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.portal')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_toolbar_title, { style: {"text-align":"center"} }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.currentPageTitle), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  "no-caps": "",
                                  onClick: _ctx.goToDashboard
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "dashboard",
                                      style: {"font-size":"1.6rem","position":"relative"},
                                      color: "primary"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.main_page')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  "no-caps": "",
                                  onClick: _ctx.onGoCautaArticole
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "category",
                                      style: {"font-size":"1.6rem","position":"relative"},
                                      color: "primary"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('message.search_items')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  "no-caps": "",
                                  onClick: _ctx.onGoToOffers
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, {
                                      name: "shop",
                                      style: {"font-size":"1.6rem","position":"relative"},
                                      color: "primary"
                                    }),
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.offers')) + " ", 1),
                                    (_ctx.userStore.countOferte>0)
                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                          key: 0,
                                          color: "red",
                                          class: "badge__superscript--top",
                                          style: {"height":"1rem","margin-left":"4px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.userStore.countOferte), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["app__color--gray", { 'text-orange': _ctx.nrArticlesInFavorites>0}])
                                }, null, 2)
                              ]),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                "no-caps": "",
                                onClick: _ctx.goToFavorite
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    left: "",
                                    name: "favorite_border",
                                    color: "red"
                                  }),
                                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('message.favorite')), 1),
                                  _createVNode(_component_q_badge, {
                                    color: "red",
                                    floating: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.nrArticlesInFavorites), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_q_btn, {
                                flat: "",
                                round: "",
                                color: "primary",
                                "text-color": "#9EADBA",
                                icon: "shopping_cart",
                                ripple: { color: 'yellow' },
                                class: "app__color--gray q-px-sm",
                                onClick: _ctx.onGoTOMyShoppingCart
                              }, null, 8, ["onClick"]),
                              _createElementVNode("div", {
                                style: {"display":"flex","flex-direction":"column","cursor":"pointer"},
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onGoTOMyShoppingCart && _ctx.onGoTOMyShoppingCart(...args)))
                              }, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('message.my_basket')), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["app__color--gray", { 'text-orange': _ctx.nrArticlesInBasket>0}])
                                }, _toDisplayString(_ctx.nrArticlesInBasket) + " " + _toDisplayString(_ctx.$t('message.items')), 3)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_ctx.userCompanies.length <= 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.user.companyName), 1))
                              : (_openBlock(), _createBlock(_component_q_select, {
                                  key: 1,
                                  outlined: "",
                                  modelValue: _ctx.user.companyName,
                                  "onUpdate:modelValue": [
                                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.companyName) = $event)),
                                    _cache[4] || (_cache[4] = val => _ctx.changeCompanyUser(val))
                                  ],
                                  options: _ctx.userCompanies,
                                  "option-value": "cif",
                                  "option-label": "denumire",
                                  class: "form__input",
                                  "emit-value": "",
                                  "map-options": ""
                                }, null, 8, ["modelValue", "options"]))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_q_select, {
                              outlined: "",
                              modelValue: _ctx.selectedLang,
                              "onUpdate:modelValue": [
                                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedLang) = $event)),
                                _cache[6] || (_cache[6] = val => _ctx.changeLanguage(val))
                              ],
                              options: _ctx.languages,
                              "option-value": "id",
                              "option-label": "name",
                              class: "form__input",
                              "emit-value": "",
                              dense: "",
                              "map-options": ""
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.userIsAuthenticated)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 4,
                            flat: "",
                            class: "app__color--label",
                            "no-caps": "",
                            label: _ctx.user.firstName+' '+_ctx.user.lastName
                          }, {
                            default: _withCtx(() => [
                              (_ctx.MyImgProfileString64.length>10)
                                ? (_openBlock(), _createBlock(_component_q_avatar, {
                                    key: 0,
                                    size: "42px",
                                    style: {"margin-left":"4px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: _ctx.MyImgProfileString64,
                                        fit: "scale-down",
                                        ratio: "1"
                                      }, null, 8, _hoisted_10)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 1,
                                    name: "person"
                                  })),
                              _createVNode(_component_q_menu, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('message.my_setting')), 1),
                                      _createVNode(_component_q_input, {
                                        outlined: "",
                                        dense: "",
                                        label: _ctx.$t('message.nr_rows_in_table'),
                                        type: "number",
                                        modelValue: _ctx.nrRanduriTabel,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nrRanduriTabel) = $event)),
                                        "lazy-rules": "",
                                        style: {"max-width":"120px","max-height":"7vh"},
                                        onInput: _ctx.setNrRanduriTabel
                                      }, null, 8, ["label", "modelValue", "onInput"]),
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        style: {"margin-top":"auto"},
                                        color: "primary",
                                        label: _ctx.$t('message.log_out'),
                                        outline: "",
                                        push: "",
                                        size: "sm",
                                        onClick: _ctx.logout
                                      }, null, 8, ["label", "onClick"]), [
                                        [_directive_close_popup]
                                      ])
                                    ]),
                                    _createVNode(_component_q_separator, {
                                      vertical: "",
                                      inset: "",
                                      class: "q-mx-lg"
                                    }),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.profile')), 1),
                                        _withDirectives(_createVNode(_component_q_icon, {
                                          left: "",
                                          size: "15px",
                                          name: "edit",
                                          onClick: _ctx.goToMyProfile,
                                          class: "is_clickable",
                                          style: {"position":"relative","top":"-7px","left":"7px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_tooltip, {
                                              "transition-show": "rotate",
                                              "transition-hide": "rotate"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.click_edit_profile')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]), [
                                          [_directive_close_popup]
                                        ])
                                      ]),
                                      (_ctx.MyImgProfileString64.length>10)
                                        ? _withDirectives((_openBlock(), _createBlock(_component_q_avatar, {
                                            key: 0,
                                            size: "72px",
                                            onClick: _ctx.goToMyProfile
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("img", { src: _ctx.MyImgProfileString64 }, null, 8, _hoisted_17)
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])), [
                                            [_directive_close_popup]
                                          ])
                                        : (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 1,
                                            color: "primary",
                                            unelevated: "",
                                            round: "",
                                            size: "lg",
                                            "no-caps": "",
                                            onClick: _ctx.goToMyProfile
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('message.imagine_profil')), 1)
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["onClick"])),
                                      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
                                      _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.user.emailAddress), 1)
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createBlock(_component_q_toolbar, { key: 1 }, {
                    default: _withCtx(() => [
                      (_ctx.showBackBar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (!_ctx.visibleMobileBarForSearch)
                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 0,
                                  name: "arrow_back_ios",
                                  onClick: _ctx.goBack,
                                  class: "app__arrow--back"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (!_ctx.visibleMobileBarForSearch)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.titleBackBar), 1))
                              : _createCommentVNode("", true),
                            (_ctx.showAddBtnBarMenu)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 2,
                                  square: "",
                                  color: "blue",
                                  icon: "add",
                                  style: {"margin-left":"auto","height":"2rem","width":"2rem"},
                                  onClick: _ctx.onClickAddBtnForDialogChild
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.showBasketBtnBarMenu && !_ctx.visibleMobileRightBtnForDashboard)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 3,
                                  flat: "",
                                  square: "",
                                  color: "primary",
                                  "text-color": "#9EADBA",
                                  icon: "shopping_cart",
                                  class: "app__color--label",
                                  style: {"margin-left":"auto","height":"2rem","width":"2rem"},
                                  onClick: _ctx.onGoTOMyShoppingCart
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_badge, {
                                      color: "red-3",
                                      floating: "",
                                      transparent: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.visibleMobileRightBtnForDashboard && !_ctx.visibleMobileBarForSearch)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  (_ctx.showBasketBtnBarMenu)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        flat: "",
                                        square: "",
                                        color: "primary",
                                        "text-color": "#9EADBA",
                                        icon: "shopping_cart",
                                        class: "app__color--label",
                                        style: {"height":"2rem","width":"2rem"},
                                        onClick: _ctx.onGoTOMyShoppingCart
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_badge, {
                                            color: "red-3",
                                            floating: "",
                                            transparent: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.showMenuBar)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (!_ctx.visibleInputFastSearch)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createVNode(_component_q_btn, {
                                    dense: "",
                                    flat: "",
                                    round: "",
                                    icon: "menu",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.leftDrawerOpen = !_ctx.leftDrawerOpen))
                                  }),
                                  (_ctx.userIsAuthenticated)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        (_ctx.userCompanies.length <= 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.user.companyName), 1))
                                          : (_openBlock(), _createBlock(_component_q_select, {
                                              key: 1,
                                              outlined: "",
                                              style: {"width":"100%"},
                                              modelValue: _ctx.user.companyName,
                                              "onUpdate:modelValue": [
                                                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.companyName) = $event)),
                                                _cache[10] || (_cache[10] = val => _ctx.changeCompanyUser(val))
                                              ],
                                              options: _ctx.userCompanies,
                                              "option-value": "cif",
                                              "option-label": "denumire",
                                              class: "form__input",
                                              "emit-value": "",
                                              "map-options": ""
                                            }, null, 8, ["modelValue", "options"]))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_30, [
                                    (_ctx.nrArticlesInFavorites>0)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 0,
                                          flat: "",
                                          round: "",
                                          color: "primary",
                                          "text-color": "#9EADBA",
                                          icon: "favorite_border",
                                          class: "app__color--label",
                                          onClick: _ctx.goToFavorite
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_badge, {
                                              color: "red-3",
                                              floating: "",
                                              transparent: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.nrArticlesInFavorites), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      round: "",
                                      color: "primary",
                                      "text-color": "#9EADBA",
                                      icon: "shopping_cart",
                                      class: "app__color--label",
                                      onClick: _ctx.onGoTOMyShoppingCart
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_badge, {
                                          color: "red-3",
                                          floating: "",
                                          transparent: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.nrArticlesInBasket), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_drawer, {
        modelValue: _ctx.leftDrawerOpen,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
        side: "left",
        behavior: "mobile",
        overlay: "",
        elevated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _hoisted_31
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_q_item, {
                clickable: "",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.leftDrawerOpen=false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        color: "primary",
                        name: "close"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_directive_ripple]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_MenuApp, {
            userid: _ctx.user.userid,
            onCloseMenu: _ctx.onCloseMenu
          }, null, 8, ["userid", "onCloseMenu"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_page_container, { style: {"min-height":"60vh"} }, {
        default: _withCtx(() => [
          (_ctx.isLoadingNomenclatoare)
            ? (_openBlock(), _createBlock(_component_q_banner, {
                key: 0,
                "inline-actions": "",
                class: "text-white bg-red"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mesajSeLoadingNomenclatoare), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_KeepAlive, null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ], 1024))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.userIsAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass(["footer__container", { condensed__footer: _ctx.currentRouteName=='Login' }])
            }, [
              (_ctx.userIsAuthenticated)
                ? (_openBlock(), _createBlock(_component_ContacteleMeleColorMetal, { key: 0 }))
                : _createCommentVNode("", true),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createElementBlock("br", _hoisted_33))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.documente')), 1)
                ]),
                _createVNode(_component_q_btn, {
                  size: "sm",
                  padding: "none",
                  flat: "",
                  "no-caps": "",
                  color: "blue-grey-4",
                  align: "left",
                  label: _ctx.$t('message.declaration_of_conformity'),
                  style: {"font-size":"14px"},
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.generarePdfDocument('declaratie', _ctx.$t('message.declaration_of_conformity'))))
                }, null, 8, ["label"]),
                _createVNode(_component_q_btn, {
                  size: "sm",
                  padding: "none",
                  flat: "",
                  "no-caps": "",
                  color: "blue-grey-4",
                  align: "left",
                  label: _ctx.$t('message.terms'),
                  style: {"font-size":"14px"},
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.generarePdfDocument('conditii', _ctx.$t('message.terms'))))
                }, null, 8, ["label"]),
                _createVNode(_component_q_btn, {
                  size: "sm",
                  padding: "none",
                  flat: "",
                  "no-caps": "",
                  color: "blue-grey-4",
                  align: "left",
                  label: _ctx.$t('message.catalogs'),
                  style: {"font-size":"14px"},
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openLink('https://color-metal.bg/bg/cataloage')))
                }, null, 8, ["label"])
              ]),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createElementBlock("br", _hoisted_36))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", null, [
                  _createVNode(_component_q_btn, {
                    padding: "xs",
                    color: "blue-grey-4",
                    icon: _ctx.ionLogoFacebook,
                    flat: "",
                    style: {"width":"2rem"},
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openLink('https://www.facebook.com/colormetalbulgaria')))
                  }, null, 8, ["icon"]),
                  _createVNode(_component_q_btn, {
                    padding: "xs",
                    color: "blue-grey-4",
                    icon: _ctx.ionLogoLinkedin,
                    flat: "",
                    style: {"width":"2rem"},
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openLink('https://www.linkedin.com/company/color-metal-bulgaria-%D0%BA%D0%BE%D0%BB%D0%BE%D1%80-%D0%BC%D0%B5%D1%82%D0%B0%D0%BB-%D0%B1%D1%8A%D0%BB%D0%B3%D0%B0%D1%80%D0%B8%D1%8F/')))
                  }, null, 8, ["icon"])
                ])
              ]),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createElementBlock("br", _hoisted_39))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.pdfDocumentDialog,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.pdfDocumentDialog) = $event)),
        "full-width": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "my_card" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row items-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                  }, _toDisplayString(_ctx.pdfDocumentTitle), 3),
                  (_ctx.$q.platform.is.desktop)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        "no-caps": "",
                        color: "primary",
                        onClick: _ctx.downloadPDF,
                        icon: "download",
                        style: {"margin-left":"1rem","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.download')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.mobile)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        "no-caps": "",
                        flat: "",
                        color: "primary",
                        icon: "download",
                        onClick: _ctx.downloadPDF,
                        style: {"cursor":"pointer"}
                      }, null, 8, ["onClick"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_space),
                  (_ctx.isLoadingDocument)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 2,
                        color: "black",
                        size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                      }, null, 8, ["size"]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoadingDocument)
                    ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.desktop)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 4,
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512)), [
                        [_directive_close_popup]
                      ])
                    : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 5,
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: "",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.widthPdf=300))
                      }, null, 512)), [
                        [_directive_close_popup]
                      ])
                ]),
                _: 1
              }),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    class: "my_card_2"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isLoadingDocument)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                            icon: "zoom_in",
                            style: {"margin-bottom":"8px"},
                            loading: _ctx.clickedZoom
                          }, null, 8, ["loading"]))
                        : _createCommentVNode("", true),
                      (!_ctx.isLoadingDocument)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                            icon: "zoom_out",
                            style: {"margin-left":"10px","margin-bottom":"8px"},
                            loading: _ctx.clickedZoom
                          }, null, 8, ["loading"]))
                        : _createCommentVNode("", true),
                      _hoisted_40,
                      _createVNode(_component_vue_pdf_embed, {
                        source: _ctx.pdfDocument,
                        width: _ctx.widthPdf
                      }, null, 8, ["source", "width"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 1,
                    class: "my_card_2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vue_pdf_embed, { source: _ctx.pdfDocument }, null, 8, ["source"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}